export function setUpgrade (state, payload) {
  state.upgrade = payload
}

export function setIsUpgrade (state, payload) {
  state.isUpgrade = payload
}

export function SetUpgradeData (state, payload = {}) {
  state.upgradeData = payload || {}
}
